<template>
  <div>OK</div>
</template>

<script>
export default {
  name: "Health"
};
</script>
